import { render, staticRenderFns } from "./UnboxBox.vue?vue&type=template&id=dc727d1e&scoped=true"
import script from "./UnboxBox.vue?vue&type=script&lang=js"
export * from "./UnboxBox.vue?vue&type=script&lang=js"
import style0 from "./UnboxBox.vue?vue&type=style&index=0&id=dc727d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc727d1e",
  null
  
)

export default component.exports